import { useEffect, useState } from 'react';
import { ToastProvider } from '@/components/base/Toast';
import { useReveal } from '@/hooks/useReveal';
import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import QuickEntrySection from '@/pages/home/components/QuickEntrySection';
import LatestEntrySection from '@/pages/home/components/LatestEntrySection';
import TopicWallSection from '@/pages/home/components/TopicWallSection';
import HotRankingSection from '@/pages/home/components/HotRankingSection';
import GuideSection from '@/pages/home/components/GuideSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  const [query, setQuery] = useState('');
  const [showTop, setShowTop] = useState(false);
  useReveal();

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <ToastProvider>
      <div className="min-h-screen bg-background-50 font-body text-foreground-950">
        <SiteHeader onSearch={setQuery} />
        <main>
          <HeroSection />
          <QuickEntrySection />
          <LatestEntrySection query={query} />
          <TopicWallSection />
          <HotRankingSection />
          <GuideSection />
          <FaqSection />
        </main>
        <SiteFooter />

        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="回到顶部"
          className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-800 transition-all hover:border-primary-400 hover:text-accent-700 ${
            showTop ? 'opacity-100' : 'pointer-events-none opacity-0'
          }`}
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </button>
      </div>
    </ToastProvider>
  );
}